import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { loaderMiddleware } from "./middleware/loaderMiddleware";
import { persistReducer, persistStore } from 'redux-persist';
import authReducer from "./slices/auth/authSlice"
import modalReducer from "./slices/modal/modalSlice"
import categoryReducer from "./slices/category/categorySlice"
import languageReducer from "./slices/language/languageSlice"
import alertReducer from "./slices/ui/alertSlice"
import loaderReducer from "./slices/ui/loaderSlice"
import foodItemsReducer from "./slices/foodItems/foodItemsSlice"
import globalMenuReducer from "./slices/globalMenu/globalMenuSlice"
import locationReducer from "./slices/location/locationSlice"
import userManagementSlice from "./slices/userManagment/userManagementSlice"
import webContentReducer from "./slices/web-content/webContentSlice"
import enquiriesReducer from "./slices/enquiries/enquirySlice"
import couponReducer from "./slices/coupons/couponsSlice"
import { injectStore } from "../utils/storeInjector";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'globalMenu'] // persist only auth
};


const appReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  category: categoryReducer,
  language: languageReducer,
  alert: alertReducer,
  loader: loaderReducer,
  foodItems: foodItemsReducer,
  globalMenu: globalMenuReducer,
  location: locationReducer,
  userManagement: userManagementSlice,
  webContent: webContentReducer,
  enquiries: enquiriesReducer,
  coupons: couponReducer
});

// This is the "Best Approach" logic
const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') { // Check for your logout action
    // 1. Clear the storage engine (localStorage/IndexedDB)
    storage.removeItem('persist:root');
    
    // 2. Setting state to undefined forces all reducers to return their initial state
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(loaderMiddleware)
});


injectStore(store)

export const persistor = persistStore(store);